/**
 * @packageDocumentation
 * @module api.functional.auth.me
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { MeResponseDto } from "../../../structures/MeResponseDto";

/**
 * @controller AuthController.getCurrentUser
 * @path GET /auth/me
 * @accessor api.functional.auth.me.getCurrentUser
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getCurrentUser(
  connection: IConnection,
): Promise<getCurrentUser.Output> {
  return PlainFetcher.fetch(connection, {
    ...getCurrentUser.METADATA,
    template: getCurrentUser.METADATA.path,
    path: getCurrentUser.path(),
  });
}
export namespace getCurrentUser {
  export type Output = MeResponseDto;

  export const METADATA = {
    method: "GET",
    path: "/auth/me",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/auth/me";
}
